import { render, staticRenderFns } from "./productupdate.vue?vue&type=template&id=6f00b8fa&scoped=true&"
import script from "./productupdate.vue?vue&type=script&lang=js&"
export * from "./productupdate.vue?vue&type=script&lang=js&"
import style0 from "./productupdate.vue?vue&type=style&index=0&id=6f00b8fa&prod&lang=scss&"
import style1 from "./productupdate.vue?vue&type=style&index=1&id=6f00b8fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f00b8fa",
  null
  
)

export default component.exports